import { render } from "./ColorePickerField.vue?vue&type=template&id=432b9c1f&scoped=true"
import script from "./ColorePickerField.vue?vue&type=script&lang=js"
export * from "./ColorePickerField.vue?vue&type=script&lang=js"

import "./ColorePickerField.vue?vue&type=style&index=0&id=432b9c1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432b9c1f"]])

export default __exports__